document.addEventListener("DOMContentLoaded", function () {
  $(document).on("click", ".form-trainees-answers .trainee-selector button", onSelectTrainee);

  if (window.location.hash) {
    document
      .querySelectorAll(`[data-trainee="${window.location.hash.replace("#", "")}"] button`)
      .forEach((traineeButton) => traineeButton.click());
  }
});

function onSelectTrainee(e) {
  let li = $(e.target).closest("li");
  let traineeId = li.attr("data-trainee");
  $(".trainee-selector").removeClass("selected");
  $(".trainee").hide();
  $(`.trainee[data-trainee=trainee-${traineeId}]`).show();
  li.addClass("selected");
}
